<div class="add-comments-modal" role="dialog" aria-modal="true">
  <div class="modal-header">
    <h2>{{ title }}</h2>
    <button
      type="button"
      class="icon-btn"
      aria-label="Close"
      (click)="onCancel()"
    >
      &times;
    </button>
  </div>

  <ng-container [ngSwitch]="data.option">
    <!-- Default add-comments form -->
    <ng-container *ngSwitchDefault>
      <form
        [formGroup]="form"
        class="modal-body"
      >
        <textarea
          id="commentInput"
          formControlName="comment"
          placeholder="Add Comments"
          rows="4"
          [attr.aria-invalid]="form.controls['comment'].invalid && form.controls['comment'].touched"
        ></textarea>
        <div
          class="error"
          *ngIf="form.controls['comment'].invalid && form.controls['comment'].touched"
        >
          Comment is required.
        </div>
        <div class="modal-footer">
          <app-button-group
            [label]="'Cancel'"
            [buttonType]="'Secondary'"
            [cssClass]="'btn cancel-btn'"
            (click)="onCancel()"
          ></app-button-group>
          <app-button-group
            [label]="'Save'"
            [buttonType]="'Primary'"
            [disabled]="form.invalid"
            [cssClass]="'btn btn-primary'"
            (click)="onSave()"
          ></app-button-group>
        </div>
      </form>
    </ng-container>

    <!-- Download confirmation -->
    <ng-container *ngSwitchCase="'download'">
      <div class="download-content">{{ content }}</div>
      <div class="modal-footer">
        <app-button-group
          [label]="'Cancel'"
          [buttonType]="'Secondary'"
          [cssClass]="'btn btn-secondary'"
          (click)="onCancel()"
        ></app-button-group>
        <app-button-group
          [label]="'Download'"
          [buttonType]="'Primary'"
          [cssClass]="'btn btn-primary'"
          (click)="onDownload()"
        ></app-button-group>
      </div>
    </ng-container>

    <!-- Generic confirmation (Save/Cancel) -->
    <ng-container *ngSwitchCase="'confirmation'">
      <div class="confirmation-content">{{ content }}</div>
      <div class="modal-footer">
        <app-button-group
          [label]="'Cancel'"
          [buttonType]="'Secondary'"
          [cssClass]="'btn cancel-btn'"
          (click)="onCancel()"
        ></app-button-group>
        <app-button-group
          [label]="'Confirm'"
          [buttonType]="'Primary'"
          [cssClass]="'btn btn-primary'"
          (click)="onConfirm()"
        ></app-button-group>
      </div>
    </ng-container>
  </ng-container>


</div>
